import { render } from "./Test2.vue?vue&type=template&id=89bb8e4c&ts=true"
import script from "./Test2.vue?vue&type=script&lang=ts"
export * from "./Test2.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__